import './style';
import { Component, h } from 'preact';
// import { Router } from 'preact-router';

import VpnClient from './components/vpn_client';
import Config from './components/config';
import MfaRegistration from './components/mfa';
import Footer from './components/footer';

export default class App extends Component {
  render (props, { results = [] }) {
    const cookies = document.cookie.split(';')
      .map((e) => e.trim().split('='))
      .reduce((acc, e) => {
        acc[e[0]] = e[1];
        return acc;
      }, {});

    return (
      <div class='content'>
        <div class='top-banner'>
          <img src='assets/layers.png' class='logo' />
          <h1>TwoPly</h1>
        </div>
        <div class='mid-banner'>
          <p>
            Localytics tools for generating extra-strong disposable certs and
            TOTP MFA tokens
          </p>
        </div>
        <div class='main-section'>
          <h2>Setup</h2>
          <div class='steps'>
            <VpnClient />
            <Config />
            <MfaRegistration />
          </div>
          <hr />
          <h2>Connecting to the VPN</h2>
          <p>
            When connecting to the VPN, you will be prompted to enter a
            username and password. Your username can be anything (it is pulled
            from the certificate) and <strong>the password is your two-factor
            code</strong>.
          </p>
          <img src='assets/tunnelblick-mfa.png' />
        </div>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./index.js